export default __webpack_public_path__ + "static/media/prev-IVTS-2.9f7cf182.png";